<clr-modal [clrModalOpen]="modalOpen()" [clrModalClosable]="false">
  <h3 class="modal-title">
    {{ (mode() == 'setup' ? 'Replikat erstellen' : 'Replikat zurückspielen') | mrTranslate }}
  </h3>
  <div class="modal-body clr-row nxm">
    @let status = progressGroup().status;
    @if (status == 'idle') {
      <div class="centred" style="height: 90px"><clr-spinner /></div>
    } @else {
      <div class="progress-group w-100-p">
        @for (child of progressGroup().children | keyvalue: null; track child.key) {
          @let progress = child.value;
          <div class="progress-block">
            @if (progress.title) {
              <label for="{{ key }}">{{ progress.title | mrTranslate }}</label>
            }
            <clr-progress-bar
              id="{{ key }}"
              clrColor="success"
              [clrValue]="progress.percent ?? progress.current"
              [clrDisplayval]="progress.percent == null ? progress.current : ''"
              [clrLabeled]="!progress.total"
              [clrLoop]="progress.percent == null" />
            @if (progress.total) {
              <span class="margin-6-l">{{ progress.current ?? 0 }} / {{ progress.total }}</span>
            }
          </div>
        }
      </div>
    }
  </div>
</clr-modal>
